import { useRouteLoaderData } from 'react-router';
import type { loader as rootLoader } from '@/root';
import type { CustomerCareLinkKind } from '@/lib/customer-care-links';

/**
 * Site-prefixed help-center href from the `customerCareLinks` site preference, or `undefined` when the
 * preference has no valid entry for this kind (or the root route errored). Callers hide the link then.
 */
export function useCustomerCareHref(kind: CustomerCareLinkKind): string | undefined {
    return useRouteLoaderData<typeof rootLoader>('root')?.customerCareHrefs[kind];
}
